// extracted by mini-css-extract-plugin
export default {"title":"GarageRefresh_title__B18GB","noticeText":"GarageRefresh_noticeText__BXWRM"};